import * as BABYLON from 'babylonjs';
import BasicComponent from './BasicComponent';
import MediaManager from '@/api/MediaManager';
import * as GUI from 'babylonjs-gui';

class Text extends BasicComponent {
    getType() { return "Text"; }

    constructor( { id } = {} ) {
        super( { id });

        this.open = false;
        this.blacklist = null;
        this.mainNode = null;
    }

    construct( context, prefab ) {

        this.context = context;
        this.prefab = prefab;

        console.log("Text construct...");
        this.initComponent();
        
        
    }

    async initComponent(){
        this.blacklist = [
            {lang:"cs",ids:[428565,428574,428583,428592,428601]},
            {lang:"sk",ids:[428565,428574,428583,428592,428601]}
        ];

        this.base = super.construct( this.context, this.prefab ).getRootNode();
        this.base.position = this.prefab.getPosition();

        if((this.prefab.getRotationX() && this.prefab.getRotationX() != 0) || (this.prefab.getRotationY() && this.prefab.getRotationY() != 0) || (this.prefab.getRotationZ() && this.prefab.getRotationZ() != 0)){
            this.base.rotation = new BABYLON.Vector3(this.prefab.getRotationX()* Math.PI / 180, this.prefab.getRotationY()* Math.PI / 180, this.prefab.getRotationZ()* Math.PI / 180);
        }else{
            this.base.lookAt(new BABYLON.Vector3(0,0,0));
        }
        
        // this.constructTextComponent(this.context,this.prefab);
        // console.log(this.context.$i18n.locale.toLowerCase());
        // console.log(this.context.$i18n.locale.toLowerCase().includes("cs"));
        if(this.blacklist.find(item => this.context.$i18n.locale.toLowerCase().includes(item.lang))){
            console.log(this.blacklist.find(item => item.lang==this.context.$i18n.locale));
            this.constructNotAvailableMenu(this.context,this.prefab);
        } else {
            this.constructTextComponent(this.context,this.prefab);
        }


        window.addEventListener("languageChange",()=>{
            this.destroyComponent();
            if(this.blacklist.find(item => this.context.$i18n.locale.toLowerCase().includes(item.lang))){
                console.log(this.blacklist.find(item => item.lang==this.context.$i18n.locale));
                this.constructNotAvailableMenu(this.context,this.prefab);
            } else {
                this.constructTextComponent(this.context,this.prefab);
            }
        })

        return this.base;
    }

    async constructTextComponent(context,prefab){
        let self = this;
        let displayPreviewText = prefab.getPreviewText() ? prefab.getPreviewText().length > 0: false;
        // displayPreviewText = false;

        let width = 15 * prefab.getScale();
        let height =  15 * prefab.getScale();

        console.log("Construct 'text' Component");

        this.mainNode = new BABYLON.TransformNode("TextComponent", window.scene);
        this.mainNode.parent = this.base;
        
        let plane = BABYLON.MeshBuilder.CreatePlane("TextPlane", { 
            width: 180,
            height: 180,
            sideOrientation: BABYLON.Mesh.DOUBLESIDE 
        }, window.scene);

        plane.parent = this.base;
        plane.isPickable = false;
        plane.renderingGroupId = 1;
        plane.rotation.y = Math.PI;
        plane.position.y = -90-7*prefab.getScale();

        // GUI
        var advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(plane);	

        // Rectangle
        var rect = new GUI.Rectangle();
        rect.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        rect.adaptWidthToChildren = true;
        rect.adaptHeightToChildren = true;
        // rect.cornerRadius = 20;
        rect.background = "white";
        rect.alpha = 0.9;
        rect.width = "40%";
        rect.thickness = 10; 
        advancedTexture.addControl(rect);

        // Text ontop of Rectanble
        var displayedText = new GUI.TextBlock();
        displayedText.text = this.context.$i18n.t(prefab.displayedText);
        // window.addEventListener("languageChange", () => {
        //     displayedText.text = this.context.$i18n.t(prefab.displayedText);
        // });
        displayedText.fontSize = "18pt";
        displayedText.color = "black";
        displayedText.lineSpacing = 2;
        displayedText.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        displayedText.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        displayedText.textWrapping = GUI.TextWrapping.WordWrap;
        displayedText.resizeToFit = true;
        displayedText.paddingTop = 20;
        displayedText.paddingLeft = 20;
        displayedText.paddingRight = 20;
        displayedText.paddingBottom = 20;
        rect.addControl(displayedText);

        if(prefab.displayOnClick == "true"){

            let previewTextGui;
            if(displayPreviewText){
                previewTextGui = BABYLON.MeshBuilder.CreatePlane("TextButton", { 
                    width: 180,
                    height: 180,
                    sideOrientation: BABYLON.Mesh.DOUBLESIDE 
                }, window.scene);

                previewTextGui.parent = this.mainNode;
                previewTextGui.isPickable = false;
                previewTextGui.renderingGroupId = 1;
                previewTextGui.position.y = 5 + 5*prefab.getScale();
                previewTextGui.rotation.y = Math.PI;
                previewTextGui.visibility = 0;
        
                var advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(previewTextGui);
                
                var previewText = new GUI.TextBlock();
                previewText.text = this.context.$i18n.t(prefab.getPreviewText());
                window.addEventListener("languageChange", () => {
                    previewText.text = this.context.$i18n.t(prefab.getPreviewText());
                });
                previewText.fontSize = "26pt";
                previewText.color = "White";
                previewText.lineSpacing = 2;
                previewText.outlineColor = "#2061AE";
                previewText.outlineWidth = "6px";
                previewText.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
                previewText.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
                previewText.resizeToFit = true;
                advancedTexture.addControl(previewText);
            }

            plane.visibility = 0;

            // Texture
            let iconMedia = MediaManager.getMedia(prefab.getIconID());
            let buttonTexture = BABYLON.RawTexture.CreateRGBATexture(iconMedia.blob, iconMedia.blob.width, iconMedia.blob.height, window.scene, true, true, BABYLON.Engine.TEXTUREFORMAT_RGBA);
            buttonTexture.wrapU = buttonTexture.wrapV = BABYLON.Constants.WRAP_ADDRESSMODE;
            buttonTexture.name = iconMedia.id;

            // Material
            let buttonMaterial = new BABYLON.StandardMaterial("", window.scene);
            buttonMaterial.disableLighting = true;  
            buttonMaterial.opacityTexture = buttonMaterial.emissiveTexture =  buttonTexture;

            //Button - OnHover Open Text
            let button = BABYLON.MeshBuilder.CreatePlane("", { 
                width: width,
                height: height,
                sideOrientation: BABYLON.Mesh.DOUBLESIDE 
            }, window.scene);
           
            button.parent = this.mainNode;
            button.rotation.y = Math.PI;
            button.rotation.z = Math.PI;
            button.renderingGroupId = 2;
            button.material = buttonMaterial;

            var ease = new BABYLON.CubicEase();
            ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
            
            button.actionManager = new BABYLON.ActionManager(window.scene);
            button.actionManager.hoverCursor = "pointer";
            button.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function(){     
                self.open = !self.open;
                BABYLON.Animation.CreateAndStartAnimation("", button, "rotation.z", 30,10, button.rotation.z, button.rotation.z+Math.PI/4, 0, ease);
                if(self.open){
                    BABYLON.Animation.CreateAndStartAnimation("", plane, "visibility", 30,10, 0, 1, 0, ease);
                }else{
                    BABYLON.Animation.CreateAndStartAnimation("", button, "scaling", 30,10, button.scaling, new BABYLON.Vector3.One(), 0, ease);
                    BABYLON.Animation.CreateAndStartAnimation("", plane, "visibility", 30,10, 1, 0, 0, ease);
                }
                    
                window.dispatchEvent(new CustomEvent("closeAllTextElements", {detail:{this: self}}));
                window.dispatchEvent(new CustomEvent("closeOtherProductMenus", {detail:{this: undefined}}));
            }));

            button.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, function(){     
                if(!self.open){
                    BABYLON.Animation.CreateAndStartAnimation("", button, "scaling", 30,10, button.scaling, new BABYLON.Vector3.One(), 0, ease);
                    if(displayPreviewText)
                        BABYLON.Animation.CreateAndStartAnimation("", previewTextGui, "visibility", 30,10, previewTextGui.visibility, 0, 0, ease);
                }
                    
            }));

            button.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, function(){
                if(!self.open){
                    BABYLON.Animation.CreateAndStartAnimation("", button, "scaling", 30,10, new BABYLON.Vector3.One(), new BABYLON.Vector3.One().scale(1.2), 0,ease);
                    if(displayPreviewText)
                        BABYLON.Animation.CreateAndStartAnimation("", previewTextGui, "visibility", 30,10, previewTextGui.visibility, 1, 0, ease);
                }
                             
            }));

            window.addEventListener('closeAllTextElements',(e) =>{
                if(e.detail.this != this){
                    if(self.open)
                        BABYLON.Animation.CreateAndStartAnimation("", button, "rotation.z", 30,10, button.rotation.z, button.rotation.z+Math.PI/4, 0, ease);

                    self.open = false;
                    BABYLON.Animation.CreateAndStartAnimation("", button, "scaling", 30,10, button.scaling, new BABYLON.Vector3.One(), 0, ease);
                    BABYLON.Animation.CreateAndStartAnimation("", plane, "visibility", 30,10, plane.visibility, 0, 0, ease);
                    if(previewTextGui)
                        BABYLON.Animation.CreateAndStartAnimation("", previewTextGui, "visibility", 30,10, previewTextGui.visibility, 0, 0, ease);
                }
            });
        }
    }

    async constructNotAvailableMenu(context,prefab){
        console.log("Construct 'not available' Button")
        this.mainNode = BABYLON.MeshBuilder.CreatePlane("Plane_na", {height: 12, width: 12, sideOrientation: BABYLON.Mesh.DOUBLESIDE} , window.scene);
        this.mainNode.parent = this.base;
        this.mainNode.rotation.y = Math.PI;
        this.mainNode.visibility = 1;

        let grid = new GUI.Grid("Root Grid");
        grid.addRowDefinition(0.5);
        grid.addRowDefinition(0.5);

        let text = new GUI.TextBlock("Text_na",context.$i18n.t("Nicht verfügbar"));
        text.fontSize = "180px";
        text.fontFamily = "Roboto";
        text.fontWeight = "600";
        text.color = "white";
        text.textWrapping = true;
        text.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_CENTER;
        text.paddingBottom = "100px";
        grid.addControl(text,0);

        let image = new GUI.Image("", context.publicPath+"/media"+context.$store.getters.mediaURL+"/data/icons/icMenuDisabled.svg");
        image.width = "50%";
        image.height = "100%";
        image.alpha = 0.2;
        grid.addControl(image,1);

        let advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(this.mainNode);
        advancedTexture.addControl(grid);
    }

    destroyComponent(){
        if(this.mainNode){
            console.log("Destroying old text component")
            this.mainNode.dispose();
            // console.log(this.mainNode);
        }
    }
}

export default Text;

